import React, { useState } from 'react';
import omit from 'lodash/omit';
import { appSettings } from '@visalex/configs';
import { DropdownOptionType, LocaleSelectorDropdown } from '@visalex/core';

import Image from 'next/image';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import qs from 'qs';

import styles from './LocaleSelector.module.scss';

const LocaleSelector = () => {
  const { t, i18n } = useTranslation();

  const { pathname, push, query } = useRouter();
  const [selectedLang, selectLang] = useState(i18n.language || 'en');
  const [show, onToggle] = useState<boolean>(false);
  const options = appSettings.supportedLanguages.map(({ language, imageUrl }) => {
    return {
      value: language,
      text: t(`action-bar.locales.${language}`),
      imageUrl,
      selected: language === i18n.language,
    };
  });

  const onSelect = async (newOption: DropdownOptionType) => {
    selectLang(newOption.value);
    onToggle(false);
    await i18n.changeLanguage(newOption.value);
    const params = omit(query, ['lang']);
    const path = `${pathname}${Object.keys(params).length > 0 ? `?${qs.stringify(params)}` : ''}`;

    if (path.includes('/help/')) {
      push('/help/', '/help/', {
        locale: newOption.value,
      });

      return;
    }

    push(path, path, {
      locale: newOption.value,
    });
  };

  return (
    <div className={styles.locale_selector}>
      <Image src="/icons/icon-language.svg" width={20} height={20} alt={t('action-bar.select')} />
      <LocaleSelectorDropdown
        show={show}
        onToggle={onToggle}
        title={t(`action-bar.locales.${selectedLang}`)}
        options={options}
        onSelect={onSelect}
      />
    </div>
  );
};

export default LocaleSelector;
